require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');

var Handlebars = require('handlebars');
var HandlebarsHelpers = require('../../../libs/handlebars/handlebars-helpers.ts');

var Template = require('text-loader!templates/checkin/customerInfo.template.html');

require('../../../libs/bootstrap/js/bootstrap-table.js');
var i18n = require("l10n");

var AvailableQueuesView = require('views/checkin/availableQueues.view.ts');

var TheView = GenericView.extend({
    el: "#customerInfo",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	initialize: function (options) {
		var self = this;

        this.customer = options ? options.customer : null;

        this.render();
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

        var templateData = {
            "customer": this.customer
        }

		$("#customerInfo").html(this.template(templateData));

        this.availableQueuesView = new AvailableQueuesView();
	},
	events: {

	},
    setCustomerData: function(customerData) {
        this.customer = customerData;
        this.render();

        this.availableQueuesView.loadAndGetAvailableQueues(this.customer);
    }
});

module.exports = TheView;